import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import CustomCard from '../../shared/CustomCard';
import { categoryCollectionMenuList, categoryEditCollectionMenuList } from '../constants';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { getCollection, showProgress } from '../../../redux/actions/DealershipActions';
import service from '../../../apis/service';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import useCategory from '../hooks/useCategory';

const CollectionContainer = ({ categoryId, handleOpen, searchValue }) => {
  const [collections, setCollections] = useState([]);
  const dispatch = useDispatch();
  const selectedId = useSelector((state) => state.categoryData.selectedId);
  const content = useSelector((state) => state.categoryData.selectedCategoryDeptCollections);
  const { fetchPartnerTypes } = useCategory();
  const collectionsRef = useRef(collections);

  useEffect(() => {
    collectionsRef.current = collections;
  }, [collections]);

  const filteredCollections = useMemo(() => {
    const collection = content?.departments?.flatMap((dept) =>
      dept.categories
        .filter((cat) => cat.id === categoryId)
        .flatMap((cat) => cat.collections.filter((col) => col.title.toLowerCase().includes(searchValue.toLowerCase()))),
    );
    return collection;
  }, [categoryId, content?.departments, searchValue]);

  useEffect(() => {
    setCollections(filteredCollections);
  }, [filteredCollections]);

  const fetchCollection = useCallback(
    async (id) => {
      dispatch(showProgress(true));
      await service
        .get(apiEndpoints.COLLECTION_DETAIL.replace('ID', id))
        .then((response) => {
          dispatch(getCollection('add', response));
          dispatch(showProgress(false));
        })
        .catch((error) => {
          console.log(error);
          dispatch(showProgress(false));
        });
    },
    [dispatch],
  );

  const handleMenuItemClick = useCallback(
    async (e, name) => {
      if (name === 'Remove Collection') {
        const clickedId = e.currentTarget.getAttribute('data-id') || e.target.getAttribute('data-id');
        const filtered = collectionsRef.current
          ?.filter((item) => item.id !== parseInt(clickedId, 10))
          .flatMap((item) => item.id);
        const payload = {
          exploreCategoryId: categoryId,
          collectionIds: filtered,
        };
        dispatch(showProgress(true));
        try {
          await service.post(apiEndpoints.CAT_COLLECTION_UPDATE, payload);
          fetchPartnerTypes(selectedId);
          notifySuccess('Collection updated successfully');
        } catch (error) {
          ErrorToast(error);
        }
        dispatch(showProgress(false));
      } else {
        const clickedId = e.currentTarget.getAttribute('data-id') || e.target.getAttribute('data-id');
        const filtered = collections?.find((item) => item.id === parseInt(clickedId, 10));
        await fetchCollection(filtered?.id);
        handleOpen(filtered?.id);
      }
    },
    [categoryId, collections, dispatch, fetchCollection, fetchPartnerTypes, handleOpen, selectedId],
  );

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      spacing={1}
      style={{ marginTop: '10px' }}
    >
      {collections?.map((card) => (
        <Grid item>
          <CustomCard
            name="collections"
            height="70px"
            width="400px"
            key={card.id}
            id={card.id}
            thumbnail={card.thumbnail}
            title={card.title}
            subTitle={`Collection ID: ${card.id}`}
            menu
            menuItems={categoryId ? categoryCollectionMenuList : categoryEditCollectionMenuList}
            handleMenuItemClick={handleMenuItemClick}
            grey
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default CollectionContainer;
